const forgotI18n = {
  "fr": {
    "title": "Mot de passe oublié",
    "subtitle": "Nous t’enverrons un lien pour réinitialiser ton mot de passe.",
    "form": {
      "email": "Email",
      "submit": "Envoyer le lien",
      "loading": "Envoi…"
    },
    "done": "Si un compte existe avec cet email, un lien de réinitialisation a été envoyé.",
    "note": "Pense à vérifier tes spams. Le lien expire dans 30 minutes.",
    "back": "Retour à la connexion",
    "errors": {
      "generic": "Une erreur est survenue.",
      "email": "Saisis un email valide."
    }
  },
  "en": {
    "title": "Forgot password",
    "subtitle": "We will send you a link to reset your password.",
    "form": {
      "email": "Email",
      "submit": "Send link",
      "loading": "Sending…"
    },
    "done": "If an account exists for this email, a reset link has been sent.",
    "note": "Please also check your spam folder. The link expires in 30 minutes.",
    "back": "Back to sign in",
    "errors": {
      "generic": "Something went wrong.",
      "email": "Please enter a valid email."
    }
  },
  "pl": {
    "title": "Zapomniałeś hasła",
    "subtitle": "Wyślemy Ci link do zresetowania hasła.",
    "form": {
      "email": "Email",
      "submit": "Wyślij link",
      "loading": "Wysyłanie…"
    },
    "done": "Jeśli konto istnieje dla tego e-maila, wysłano link resetujący.",
    "note": "Sprawdź też folder spam. Link wygasa po 30 minutach.",
    "back": "Powrót do logowania",
    "errors": {
      "generic": "Wystąpił błąd.",
      "email": "Podaj poprawny adres email."
    }
  },
  "es": {
    "title": "¿Has olvidado tu contraseña?",
    "subtitle": "Te enviaremos un enlace para restablecer tu contraseña.",
    "form": {
      "email": "Email",
      "submit": "Enviar enlace",
      "loading": "Enviando…"
    },
    "done": "Si existe una cuenta asociada a este email, se ha enviado un enlace de restablecimiento.",
    "note": "Revisa también tu carpeta de spam. El enlace caduca en 30 minutos.",
    "back": "Volver al inicio de sesión",
    "errors": {
      "generic": "Ha ocurrido un error.",
      "email": "Introduce un email válido."
    }
  },
  "it": {
    "title": "Password dimenticata",
    "subtitle": "Ti invieremo un link per ripristinare la password.",
    "form": {
      "email": "Email",
      "submit": "Invia il link",
      "loading": "Invio..."
    },
    "done": "Se esiste un account per questa e-mail, è stato inviato un link di reset.",
    "note": "Controlla anche la cartella spam. Il link scade tra 30 minuti.",
    "back": "Torna a firmare",
    "errors": {
      "generic": "Qualcosa è andato storto.",
      "email": "Inserisci una email valida."
    }
  },
  "de": {
    "title": "Passwort vergessen",
    "subtitle": "Wir senden Ihnen einen Link, um Ihr Passwort zurückzusetzen.",
    "form": {
      "email": "E-Mail",
      "submit": "Senden Sie Link",
      "loading": "Senden..."
    },
    "done": "Wenn ein Konto für diese E-Mail existiert, wurde ein Reset-Link gesendet.",
    "note": "Bitte überprüfen Sie auch Ihren Spam-Ordner. Der Link läuft in 30 Minuten ab.",
    "back": "Zurück zur Anmeldung",
    "errors": {
      "generic": "Irgendetwas ging schief.",
      "email": "Bitte geben Sie eine gültige E-Mail ein."
    }
  },
  "pt": {
    "title": "Esqueceu a senha",
    "subtitle": "Enviaremos um link para redefinir sua senha.",
    "form": {
      "email": "E- mail",
      "submit": "Enviar link",
      "loading": "Enviando..."
    },
    "done": "Se existir uma conta para este email, foi enviado um link de reset.",
    "note": "Verifique também sua pasta de spam. O link expira em 30 minutos.",
    "back": "Voltar para iniciar sessão",
    "errors": {
      "generic": "Algo correu mal.",
      "email": "Digite um e-mail válido."
    }
  },
  "cs": {
    "title": "Zapomněl heslo",
    "subtitle": "Pošleme vám odkaz na resetování hesla.",
    "form": {
      "email": "E-mail",
      "submit": "Poslat odkaz",
      "loading": "Posílám..."
    },
    "done": "Pokud existuje účet pro tento e-mail, byl odeslán reset odkaz.",
    "note": "Zkontrolujte prosím také složku spamu. Spojení vyprší za 30 minut.",
    "back": "Zpět k přihlášení",
    "errors": {
      "generic": "Něco se pokazilo.",
      "email": "Zadejte prosím platný e-mail."
    }
  },
  "nl": {
    "title": "Wachtwoord vergeten",
    "subtitle": "Wij sturen u een link om uw wachtwoord te resetten.",
    "form": {
      "email": "E-mail",
      "submit": "Verwijzing versturen",
      "loading": "Verzenden..."
    },
    "done": "Als er een account bestaat voor deze e-mail, is er een resetlink verzonden.",
    "note": "Controleer ook uw spammap. De verbinding verloopt over 30 minuten.",
    "back": "Terug om in te tekenen",
    "errors": {
      "generic": "Er ging iets mis.",
      "email": "Voer een geldige e-mail in."
    }
  }
};

export default forgotI18n;
